// extracted by mini-css-extract-plugin
module.exports = {"container":"Comments_container__2j1dF","showHideButton":"Comments_showHideButton__34GnQ"};